import styled from 'styled-components'

interface IBudgetCategoryCardAttributesStyledProps {}

export const BudgetCategoryCardAttributesStyled = styled.div<IBudgetCategoryCardAttributesStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};
  background: ${(props) => props.theme.colors.offwhite};
  border-top: 1px solid ${(props) => props.theme.colors.lightGrey};
  padding: ${(props) => props.theme.typography.pxToRem(8)}
    ${(props) => props.theme.typography.pxToRem(24)};

  th {
    text-align: left;
    padding: ${(props) => props.theme.typography.pxToRem(4)}
      ${(props) => props.theme.typography.pxToRem(24)}
      ${(props) => props.theme.typography.pxToRem(4)} 0;
  }

  td {
    text-align: left;
    padding: ${(props) => props.theme.typography.pxToRem(4)} 0;
  }
`
